import { combineReducers } from '@reduxjs/toolkit';
import websiteFiltersOptions from './options/slice';
import websiteFiltersValues from './values/slice';

export default combineReducers({
  websiteFiltersOptions,
  websiteFiltersValues,
});
